import { render, staticRenderFns } from "./artistsList.vue?vue&type=template&id=84578890&scoped=true&"
import script from "./artistsList.vue?vue&type=script&lang=ts&"
export * from "./artistsList.vue?vue&type=script&lang=ts&"
import style0 from "./artistsList.vue?vue&type=style&index=0&id=84578890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84578890",
  null
  
)

export default component.exports